import watchSoundsActions from 'app/store/effects/media/sounds.saga'
import watchEbooksActions from 'app/store/effects/media/ebooks.saga'
import {
  watchKnowledgeBuilderActions,
  watchKnowledgeBuildersActions,
} from 'app/store/effects/media/knowledge.saga'

const mediaSagas = [
  watchSoundsActions(),
  watchEbooksActions(),
  watchKnowledgeBuilderActions(),
  watchKnowledgeBuildersActions(),
]

export default mediaSagas
